export const ru = {
    'success-change': 'Продукт успешно обновлен'
};
